module.exports = __webpack_public_path__ + "img/DarkPeony.24d6a11c.jpg";